// ============================================================
// Report facts and the prepared answer for the `report-comment` AI
// task (#72). Plain JS without aliases: the Worker imports the demo.
// Demo comments are Czech or English; the AI writes in any language.
// ============================================================

const r1 = (n) => Math.round(n * 10) / 10;

// Only the numbers the report itself shows.
export function reportFacts(kind, report) {
  if (kind === 'daily') {
    const byCarrier = {};
    report.missing.forEach(m => { byCarrier[m.carrier] = (byCarrier[m.carrier] || 0) + 1; });
    return {
      date: report.date.slice(0, 10), planned: report.planned, loaded: report.loaded, noShows: report.noShows,
      informedAt13Pct: report.informedPct, followUps: report.urgencies, resolvedAutomatically: report.autoResolved,
      stillOpenWithPlanner: report.open.length, noShowsByCarrier: byCarrier,
    };
  }
  const k = report.kpis;
  return {
    from: report.from.slice(0, 10), to: report.to.slice(0, 10),
    noShowsPerDay: { week: r1(k.noShows.now), beforePilot: r1(k.noShows.before) },
    informedAt13Pct: { week: r1(k.informedPct.now), beforePilot: r1(k.informedPct.before) },
    parkingTrucksPerNight: { week: r1(k.parkingTrucks.now), beforePilot: r1(k.parkingTrucks.before) },
    worstCarriers: report.worst.map(w => ({ name: w.carrier.name, noShowPct: r1(w.now.noShowPct) })),
  };
}

const n = (v, l) => Number(v).toLocaleString(l === 'cs' ? 'cs-CZ' : 'en-GB', { maximumFractionDigits: 1 });

export function reportCommentDemo({ kind, lang, facts: f }) {
  const l = lang === 'cs' ? 'cs' : 'en';
  if (kind === 'daily') {
    const worst = Object.entries(f.noShowsByCarrier).sort((a, b) => b[1] - a[1])[0];
    return l === 'cs' ? {
      headline: `Naloženo ${f.loaded} z ${f.planned} plánovaných aut, ${f.noShows} nepřijelo bez avíza.`,
      points: [
        `Ve 13:00 jsme věděli o ${f.informedAt13Pct} % nakládek, automatická urgence vyřešila ${f.resolvedAutomatically} z ${f.followUps}.`,
        worst ? `Nejvíc chybělo aut od ${worst[0]} (${worst[1]}).` : 'Všichni dopravci dorazili podle plánu.',
      ],
      action: f.stillOpenWithPlanner ? `Zítra ráno dořešit ${f.stillOpenWithPlanner} otevřené nakládky s plánovačem.` : 'Nic otevřeného nezůstalo.',
    } : {
      headline: `${f.loaded} of ${f.planned} planned trucks loaded, ${f.noShows} did not come without notice.`,
      points: [
        `At 13:00 we knew about ${f.informedAt13Pct} % of loadings; the automatic follow-up resolved ${f.resolvedAutomatically} of ${f.followUps}.`,
        worst ? `Most missing trucks were from ${worst[0]} (${worst[1]}).` : 'All carriers came as planned.',
      ],
      action: f.stillOpenWithPlanner ? `Tomorrow morning, close ${f.stillOpenWithPlanner} open loadings with the planner.` : 'Nothing is left open.',
    };
  }
  const w = f.worstCarriers[0];
  const drop = Math.round((1 - f.noShowsPerDay.week / f.noShowsPerDay.beforePilot) * 100);
  return l === 'cs' ? {
    headline: `Nepřijetí bez avíza kleslo o ${drop} % proti stavu před pilotem (${n(f.noShowsPerDay.week, l)} denně místo ${n(f.noShowsPerDay.beforePilot, l)}).`,
    points: [
      `Ve 13:00 víme o ${n(f.informedAt13Pct.week, l)} % nakládek (před pilotem ${n(f.informedAt13Pct.beforePilot, l)} %).`,
      `Parkoviště Jeseník: ${n(f.parkingTrucksPerNight.week, l)} aut za noc místo ${n(f.parkingTrucksPerNight.beforePilot, l)}.`,
    ],
    action: w ? `Projednat s ${w.name} jeho ${n(w.noShowPct, l)} % nepřijetí bez avíza.` : 'Bez doporučení.',
  } : {
    headline: `No-shows without notice are down ${drop} % against before the pilot (${n(f.noShowsPerDay.week, l)} a day instead of ${n(f.noShowsPerDay.beforePilot, l)}).`,
    points: [
      `At 13:00 we know about ${n(f.informedAt13Pct.week, l)} % of loadings (${n(f.informedAt13Pct.beforePilot, l)} % before the pilot).`,
      `Jeseník parking: ${n(f.parkingTrucksPerNight.week, l)} trucks a night instead of ${n(f.parkingTrucksPerNight.beforePilot, l)}.`,
    ],
    action: w ? `Discuss with ${w.name} its ${n(w.noShowPct, l)} % no-shows without notice.` : 'No recommendation.',
  };
}
